import React, { useEffect, useState } from 'react'
import Applayout from './layout/applayout'
import { Link } from 'react-router-dom';
import axiosClient from '../axios/axiosClient';
import { toast } from 'react-toastify';
import Pagination from '../components/app/pagination';
import Loader from '../components/app/loader';

function ApprovedCases() {
    const [cases, setCases] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({});

    const getApprovedCases = (url='/beneficiary-cases/approved-cases') => {
        setLoading(true);
        axiosClient
            .get(url)
            .then((response) => {
                setCases(response.data.data.data);
                setPagination(response.data.data)
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                toast.error(error.response?.data?.message || 'Error fetching approved cases');
            });
    };

    const handlePageChange = (url) => {
        getApprovedCases(url);
    };

    useEffect(() => {
        getApprovedCases();
    }, []);

    // Format date helper function
    const formatDate = (dateString) => {
        const options = { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    return (
        <Applayout>
            <div className="container-fluid">
                <div className="page-header">
                    <div className="row">
                        <div className="col">
                            <div className="page-header-left">
                                <h3>Approved Cases</h3>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">
                                            <i data-feather="home"></i>
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Cases</li>
                                    <li className="breadcrumb-item active">Approved</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header">
                    <h4 className="card-title mb-0">
                        Approved Cases
                        <div className="pull-right">
                            <span style={{fontSize:"12px"}} className="mx-3">
                                Total Approved Cases: <span className="badge badge-success">{cases.length}</span>
                            </span>
                        </div>
                    </h4>
                </div>
                {!loading ? (
                    <div className="table-responsive">
                        <table className="table card-table table-vcenter text-nowrap">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Title</th>
                                    <th>Beneficiary</th>
                                    <th>Project Officer</th>
                                    <th>Case Manager</th>
                                    <th>Amount Needed</th>
                                    <th>Date Approved</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cases.map((cas, index) => {
                                    // Calculate the correct index based on current page
                                    const currentPage = pagination.current_page;
                                    const perPage = pagination.per_page;
                                    const correctIndex = (currentPage - 1) * perPage + index + 1;

                                    return (
                                        <tr key={cas.id}>
                                            <td>{correctIndex}</td>
                                            <td>{cas.title}</td>
                                            <td>{cas.beneficiary.first_name + " " + cas.beneficiary.last_name}</td>
                                            <td>{cas.project_officer.first_name + " " + cas.project_officer.last_name}</td>
                                            <td>
                                                {cas.case_manager ? 
                                                    `${cas.case_manager.first_name} ${cas.case_manager.last_name}` : 
                                                    'Not Assigned'
                                                }
                                            </td>
                                            <td style={{fontSize:"9px"}}>
                                                <span>USD: <b>{cas.amount.toLocaleString()}</b></span><br/>
                                                {cas.amount_in_local && <>
                                                    <span>{cas.currency}:<b>{cas.amount_in_local.toLocaleString()}</b></span><br/>
                                                    <span>rate <b>{cas.local_rate}</b></span>
                                                </>}
                                            </td>
                                            <td>{formatDate(cas.created_at)}</td>
                                            <td>
                                                <Link 
                                                    className="btn btn-success btn-sm" 
                                                    to={`/view-case/${cas.id}`}
                                                    title="View Case"
                                                >
                                                    <i className="fa fa-eye"></i> View Case
                                                </Link>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <Pagination paginationData={pagination} onPageChange={handlePageChange} />
                    </div>
                ) : (
                    <Loader />
                )}
            </div>
        </Applayout>
    )
}

export default ApprovedCases;
